<template>
  <div class="proof-card grid-item">
    <div class="grid-item-container">
      <v-row dense>
        <v-col cols="12" class="pt-4 pr-4">
          <h5 class="color light-gray text-right">{{ proof.proof_date | prettyDate }}</h5>
          <h6 class="color light-gray text-right">{{ proof.email_address }}</h6>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <h4 class="color light-gray text-center">{{ proof.offer_summary }}</h4>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-img :src="proof.proof_image_url" cover :eager="true" />
        </v-col>
      </v-row>

      <v-row dense class="mt-0 py-4 px-6 text-center">
        <v-col cols="6">
          <v-btn color="primary" @click="showApprovalModal = true">Approve</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn color="darken-1" @click="showDenialModal = true">Deny</v-btn>
        </v-col>
      </v-row>
    </div>

    <SwayOfferDenyModal
      v-if="showDenialModal"
      :proof-id="proof.id"
      @sway-offer-deny-modal-close="showDenialModal = false"
      @sway-offer-deny-modal-proof-denied="removeProof(proof.id)"
    />

    <SwayOfferApproveModal
      v-if="showApprovalModal"
      :proof-id="proof.id"
      @sway-offer-approve-modal-close="showApprovalModal = false"
      @sway-offer-approve-modal-proof-approved="removeProof(proof.id)"
    />
  </div>
</template>

<script>
import SwayOfferDenyModal from '@/components/SwayOffers/SwayOfferDenyModal'
import SwayOfferApproveModal from '@/components/SwayOffers/SwayOfferApproveModal'

export default {
  name: 'SwayOfferProofApprovalCard',

  components: {
    SwayOfferDenyModal,
    SwayOfferApproveModal,
  },

  props: {
    proof: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showDenialModal: false,
    showApprovalModal: false,
  }),

  methods: {
    removeProof(proofId) {
      this.showDenialModal = false
      this.showApprovalModal = false

      this.$emit('sway-offer-approval-card-proof-reviewed', proofId)
    },
  },
}
</script>

<style scoped>
.proof-card {
  border: solid 1px #eee;
  border-radius: 10px;
}
</style>
